
import Questions from 'components/Questions'

export function Faq() {

  return (
      <Questions />
  )
}
